<template>
    <div>

        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow border-0">
                        <div  style="min-height: 600px;">
                                <h2 class="sentrao">Soporte</h2>
                                <div class="dropdown-divider"></div>
                                <p>Como ya sabrán, la plataforma se encuentra actualmente en fase de desarrollo con lo que puede haber algún error o fallo durante su uso. Se pide por ello que se reporte cualquier problema en el correo que se facilita a continuación para poder ser revisado y arreglado en el menor tiempo posible.</p>
                                <p>Como siempre, trabajamos para que tengan la mejor experiencia.</p>
                                <h3 class="sentrao">Contacto</h3>
                                <h5 class="sentrao"><a href="mailto:narrefle.oficial@gmail.com">Email</a></h5>
                                
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    
  }
</script>
<style>
    .sentrao{
        text-align: center;
    }
    p{
        padding: 10px;
        margin: 5px;
    }
</style>
